// extracted by mini-css-extract-plugin
module.exports = {"cb-overlay":"Overlay_cb-overlay__3wvXd"};